<script>
import IconDrop from "./Icons/IconDrop.vue";

export default {
    name: "NumberInput",
    components: {IconDrop},
    props: {
        disabled: Boolean,
        placeholder: String,
        value: [String, Number],
        min: {
            type: [Number, String],
            default: 0,
        },
        inputClass: String,
    },
    data() {
        return {
            inputValue: this.value,
            firstInteraction: false,
        }
    },
    methods: {
        prevStep() {
            if ( this.disabled ) return;
            this.inputValue = Number(this.inputValue) <= this.min ? this.min : Number(this.inputValue) - 1
        },
        nextStep() {
            if ( this.disabled ) return;
            
            if ( typeof this.inputValue === "undefined" && isNaN(this.inputValue)) {
                this.inputValue = 1;
                return;
            }
            
            this.inputValue = Number(this.inputValue) + 1;
        }
    },
    watch: {
        value(newValue, oldValue) {
            if ( newValue !== oldValue ) {
                this.firstInteraction = true;
                
                if ( newValue === 0 ) {
                    this.inputValue = '';
                }
                else {
                    this.inputValue = newValue;
                }
            }
        },
        inputValue(newValue, oldValue) {
            if ( newValue !== oldValue ) {
                this.$emit("change", Number(this.inputValue));
            }
        }
    },
}
</script>

<template>
    <div class="desktop-input desktop-input--number" :class="{'selected': inputValue !== null && firstInteraction}">
        <input type="number" v-model="inputValue" :min="min" :disabled="disabled" :placeholder="placeholder" class="" :class="inputClass">
        <button @click="nextStep" :disabled="disabled" class="btn-top" aria-label="Increase the number by 1"><IconDrop/></button>
        <button @click="prevStep" :disabled="disabled" class="btn-bottom" aria-label="Decrease the number by 1"><IconDrop/></button>
    </div>
</template>

<style scoped lang="scss">

</style>